import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { communicationApi, type CommunicationDashboard } from '../../api/communication';

export function CommunicationAnalyticsPage() {
  const [dashboard, setDashboard] = useState<CommunicationDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void communicationApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  if (!dashboard && !error) {
    return <div className="p-6">Loading analytics…</div>;
  }

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/communication" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Communication Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Communication Analytics</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {dashboard && (
        <div className="mt-6 grid gap-4 sm:grid-cols-2">
          <MetricCard label="Delivery Rate" value={`${dashboard.delivery_rate.toFixed(1)}%`} />
          <MetricCard label="Open Rate" value={`${dashboard.open_rate}%`} />
          <MetricCard label="Click Rate" value={`${dashboard.click_rate}%`} />
          <MetricCard label="Failed (24h)" value={dashboard.messages_failed_24h} />
          <MetricCard label="Scheduled Campaigns" value={dashboard.scheduled_campaigns} />
          <MetricCard label="Active Campaigns" value={dashboard.active_campaigns} />
        </div>
      )}
    </div>
  );
}

function MetricCard({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
      <p className="text-sm text-slate-500">{label}</p>
      <p className="mt-1 text-2xl font-semibold">{value}</p>
    </div>
  );
}
